import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { UserService } from './data/user.service';
import { FileSaverService } from './data/file-saver.service';
import { UtilsObjects } from './';

import { ApplicationHttpInterceptor } from './data/base/http.interceptor';
import { CacheInterceptor } from './data/base/cache.interceptor';
//import { GeneralHttpInterceptor } from './data/base/http-general.interceptor';
import { ToastErrorHandler } from './error-handler/toast-error-handler';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },

  { provide: HTTP_INTERCEPTORS, useClass: ApplicationHttpInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: GeneralHttpInterceptor, multi: true },
];

//Create a CoreModule with providers for the singleton services you load when the application starts.
@NgModule({
  imports: [
    CommonModule
  ],

  //Consider making CoreModule a pure services module with no declarations.
  //declarations: []

  providers: [
    UserService,
    FileSaverService,
    UtilsObjects,
    httpInterceptorProviders,
    { provide: ErrorHandler, useClass: ToastErrorHandler },
    //{ provide: ErrorHandler, useClass: AppErrorHandler },
    //{ provide: RouterStateSerializer, useClass: CustomSerializer }
  ],
})

export class CoreModule {
  //Import CoreModule in the root AppModule only. Never import CoreModule in any other module.
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule only.');
    }
  }
}
